// THE HOSPITAL'S OWN NUMBER FOR A PERSON — read through one function.
//
// Under one patient row (doc/one-patient-row.md §2) a human is ONE `patients`
// row and a hospital never copies it: it ALLOCATES its own number to it. That
// number therefore moved off the person and onto the allocation, where the API
// answers it as `hospitalPatientCode`. `tenantPatientCode` is the SAME value
// under the key four shipped clients already read, kept for one release.
//
// Every screen asks through here so that none of them has to know which of the
// two keys the server it is talking to happens to send. A screen that reads
// `patient.tenantPatientCode` directly shows a blank number the day the alias
// goes — which is a number the desk quotes out loud, so a blank is not a
// cosmetic failure.
export const hospitalPatientCode = (patient) =>
    patient?.hospitalPatientCode || patient?.tenantPatientCode || null;

export default hospitalPatientCode;
